// extracted by mini-css-extract-plugin
export default {"component":"rings_component_O2Myy","ring":"rings_ring_c9jKd","top":"rings_top_GD_J9","bottom":"rings_bottom_QBqvZ","large":"rings_large_WwGj1"};